class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    // this.lineItemStatusElement =
    //   document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  getLineItemStatusElement() {
    // Prefer the one inside the drawer if present; fall back to main cart.
    return (
      document.querySelector('cart-drawer .drawer__inner #CartDrawer-LineItemStatus') ||
      document.getElementById('CartDrawer-LineItemStatus') ||
      document.getElementById('shopping-cart-line-item-status')
    );
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          // enforceBagEmptyUI();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        // const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        const updatedValue =
        parsedState.items && parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        // enforceBagEmptyUI();
      })
      .catch(() => {
        this.querySelectorAll('.loading-bar__wrapper').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    if (!message) return;
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    // if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    if (lineItemError) {
    const errorText = lineItemError.querySelector('.cart-item__error-text');

      if (errorText) {
        errorText.textContent = message;
        lineItemError.removeAttribute("hidden");
        lineItemError.style.opacity = "1";
  
        setTimeout(() => {
          lineItemError.style.opacity = "0";
          setTimeout(() => {
            lineItemError.setAttribute("hidden", true);
          }, 500);
        }, 3000);
      }
    }

    // this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const lineItemStatusElement = this.getLineItemStatusElement();
    if (lineItemStatusElement) lineItemStatusElement.setAttribute('aria-hidden', 'true');

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    // cartStatus.setAttribute('aria-hidden', false);

    // setTimeout(() => {
    //   cartStatus.setAttribute('aria-hidden', true);
    // }, 1000);
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', 'false');
      setTimeout(() => cartStatus.setAttribute('aria-hidden', 'true'), 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-bar__wrapper`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-bar__wrapper`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
     // Ensure lineItemStatusElement exists before calling setAttribute
    // if (this.lineItemStatusElement) {
    //     this.lineItemStatusElement.setAttribute('aria-hidden', false);
    // } else {
    //     console.error("lineItemStatusElement not found.");
    // }
    const lineItemStatusElement = this.getLineItemStatusElement();
    if (lineItemStatusElement) {
      lineItemStatusElement.setAttribute('aria-hidden', 'false');
    } else {
      // keep this quiet or console.debug if you prefer
      console.debug('lineItemStatusElement not found (enableLoading)');
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-bar__wrapper`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-bar__wrapper`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    const lineItemStatusElement = this.getLineItemStatusElement();
    if (lineItemStatusElement) {
      lineItemStatusElement.setAttribute('aria-hidden', 'true');
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

window.requestWishlistRefresh = window.requestWishlistRefresh || function(){};

// --- Drawer Tab UI ---------------------------------------------------------
function setDrawerTab(active) {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const inner   = drawer.querySelector('.drawer__inner');
  const pane    = inner?.querySelector('#WishlistPane');
  const bagBtn  = inner?.querySelector('.drawer__tab--bag[data-tab="bag"]');
  const wishBtn = inner?.querySelector('.drawer__tab--wishlist[data-tab="wishlist"]');
  const itemsEl = inner?.querySelector('cart-drawer-items');
  const footer  = inner?.querySelector('.drawer__footer, .cart-drawer__footer');
  const emptyEl = inner?.querySelector('.drawer__inner-empty');

  const isWishlist = active === 'wishlist';
  drawer.classList.toggle('drawer--wishlist-active', isWishlist);
  drawer.classList.toggle('drawer--bag-active', !isWishlist);

  bagBtn?.classList.toggle('is-active', !isWishlist);
  wishBtn?.classList.toggle('is-active', isWishlist);
  bagBtn?.setAttribute('aria-selected', String(!isWishlist));
  wishBtn?.setAttribute('aria-selected', String(isWishlist));
  if (pane) pane.hidden = !isWishlist;

  const isEmpty = drawer.classList.contains('is-empty');
  if (isWishlist) {
    if (emptyEl) emptyEl.style.display = 'none';
    if (itemsEl) itemsEl.style.display = 'none';
    if (footer)  footer.style.display  = 'none';
  } else {
    if (isEmpty) {
      if (emptyEl) emptyEl.style.display = '';
      if (itemsEl) itemsEl.style.display = 'none';
      if (footer)  footer.style.display  = 'none';
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      if (itemsEl) itemsEl.style.display = '';
      if (footer)  footer.style.display  = '';
    }
  }
}

// delegate clicks (survives HTML swaps)
document.addEventListener('click', (e) => {
  const wish = e.target.closest('cart-drawer .drawer__tab--wishlist[data-tab="wishlist"]');
  if (wish) {
    e.preventDefault();
    setDrawerTab('wishlist');
    // if you have your refresh function, nudge it:
    if (typeof requestWishlistRefresh === 'function') {
      requestWishlistRefresh({ force: true, delay: 0 });
    }
    return;
  }
  const bag = e.target.closest('cart-drawer .drawer__tab--bag[data-tab="bag"]');
  if (bag) {
    e.preventDefault();
    setDrawerTab('bag');
  }
});

// default to bag on load
document.addEventListener('DOMContentLoaded', () => setDrawerTab('bag'));

// after Shopify replaces sections, re-apply current tab
document.addEventListener('cart:sections-updated', () => {
  const activeIsWishlist = document.querySelector('cart-drawer')?.classList.contains('drawer--wishlist-active');
  setDrawerTab(activeIsWishlist ? 'wishlist' : 'bag');
});


document.addEventListener('wishlist:refresh-needed', () => {
  requestWishlistRefresh({ force: false, delay: 150 });
});

// --- Froonze Wishlist: robust, single-flight refresh ------------------------
(function () {
  function getPane() {
    return document.querySelector('cart-drawer .drawer__inner #WishlistPane');
  }
  function drawerIsOnWishlist() {
    return document.querySelector('cart-drawer')?.classList.contains('drawer--wishlist-active');
  }

  // Detect if Froonze has already mounted a widget in the pane
  function paneHasWidget(pane) {
    return Boolean(
      pane.querySelector('.frcp-popup-wrapper, [data-frcp-widget-root], .frcp-wishlist-widget, .frcp-wishlist') ||
      pane.firstElementChild
    );
  }

  // --- single-flight + throttle state
  let buildInFlight = false;
  let lastBuildAt = 0;
  let refreshTimer = null;
  const MIN_INTERVAL_MS = 800; // throttle window

  window.requestWishlistRefresh = function requestWishlistRefresh(opts = { force: false, delay: 250 }) {
    if (!drawerIsOnWishlist()) return;
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => refreshWishlistPane(opts), opts.delay || 0);
  };

  function refreshWishlistPane({ force = false } = {}) {
    const pane = getPane();
    if (!pane) return;

    // Throttle
    const now = Date.now();
    if (!force && now - lastBuildAt < MIN_INTERVAL_MS) return;

    // If a build is already happening, bail (the pending request will get the new state)
    if (buildInFlight) return;

    // If we already have a widget mounted and not forcing, skip
    if (!force && paneHasWidget(pane)) return;

    // Wait for API readiness (once)
    let tries = 40;
    (function waitForAPI() {
      if (window.frcp?.wishlist?.buildWidgetAtPlaceholder) {
        doBuild();
      } else if (tries-- > 0) {
        setTimeout(waitForAPI, 100);
      } else {
        console.warn('Froonze wishlist API not ready.');
      }
    })();

    function doBuild() {
      // Guard again in case something changed while waiting
      if (!force && paneHasWidget(pane)) return;

      buildInFlight = true;
      lastBuildAt = Date.now();

      // Clear only our pane before (re)building to avoid layered trees
      pane.innerHTML = '';

      try {
        const ret = window.frcp.wishlist.buildWidgetAtPlaceholder(pane);
        pane.hidden = false;

        const done = () => { buildInFlight = false; };
        if (ret && typeof ret.then === 'function') {
          ret.then(done).catch((e) => { console.error(e); buildInFlight = false; });
        } else {
          done();
        }
      } catch (e) {
        console.error('Wishlist build failed:', e);
        buildInFlight = false;
      }
    }
  }

  // ----------------- Centralize all triggers here -----------------

  // A) After your cart section swaps finish  
  document.addEventListener('wishlist:refresh-needed', () => {
    window.requestWishlistRefresh({ force: false, delay: 150 });
  });

  // B) When user switches to the Wishlist tab → ensure it mounts (force here is fine)
  document.addEventListener('click', (e) => {
    const tabBtn = e.target.closest('cart-drawer .drawer__tab--wishlist[data-tab="wishlist"]');
    if (tabBtn) window.requestWishlistRefresh({ force: true, delay: 0 });
  });

  // C) After any “add/remove wishlist” click across the site
  const WISHLIST_TOGGLE_SELECTOR = [
    '[data-frcp*="wishlist"]',
    '[data-frcp-wishlist]',
    '[data-action*="wishlist"]',
    '.frcp-wishlist',
    '.frcp__wishlist',
    '.wishlist-toggle',
    '.wishlist__button',
    '.wishlist-btn'
  ].join(',');

  document.addEventListener('click', (e) => {
    if (!document.querySelector('cart-drawer')?.classList.contains('drawer--wishlist-active')) return;
    if (e.target.closest(WISHLIST_TOGGLE_SELECTOR)) {
      window.requestWishlistRefresh({ force: false, delay: 350 });
    }
  });

  // D) If the SDK ever dispatches a reliable event — prefer this (no force, throttled)
  window.addEventListener('frcp:wishlist:updated', () => {
    if (document.querySelector('cart-drawer')?.classList.contains('drawer--wishlist-active')) {
      window.requestWishlistRefresh({ force: false, delay: 150 });
    }
  });

  // E) Optional: when the drawer is opened from the header, default to Bag tab
  document.addEventListener('click', (e) => {
    if (e.target.closest('#cart-icon-bubble')) {
      setTimeout(() => {
        // setTabUI('bag');
      }, 0);
    }
  });
})();




$(document).ready(function () {
  function appendAddOverlay() {
    const isWishlistActive = $('.drawer__tab.drawer__tab--wishlist').hasClass('is-active');
    if (!isWishlistActive) {
      $('.select-overlay-text').remove();
      return;
    }

    $('.frcp-product__select').each(function () {
      const $select = $(this);
      if ($select.next('.select-overlay-text').length === 0) {
        const $overlay = $('<span class="select-overlay-text">move</span>');
        $select.after($overlay);
      }
    });
  }

  // 🟢 Run when wishlist becomes active
  $(document).on('click', '.drawer__tab.drawer__tab--wishlist', function () {
    const waitForWishlist = setInterval(() => {
      if ($('.frcp-product__select').length > 0) {
        appendAddOverlay();
        clearInterval(waitForWishlist);
      }
    }, 200);
  });

  // 🔴 Clean up when switching to Bag
  $(document).on('click', '.drawer__tab.drawer__tab--bag', function () {
    $('.select-overlay-text').remove();
  });

  // 🟡 Also run when Froonze dispatches an update
  window.addEventListener('frcp:wishlist:updated', appendAddOverlay);
});







$(document).on('click', '.frcp-product__select', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $select = $(this);
  const options = $select.find('option');

  // Remove existing popups first
  $('.custom-size-popup').remove();

  // Build popup container
  const $popup = $('<div class="custom-size-popup"></div>');
  const $popupList = $('<ul class="custom-size-popup-list"></ul>');

  // Build list items
  options.each(function () {
    const sizeText = $(this).text().trim();
    const variantId = $(this).data('variant-id');
    if (!variantId) return; // skip invalid ones

    const $li = $('<li class="custom-size-popup-list__item"></li>');
    const $btn = $(`<button class="custom-size-option" data-vid="${variantId}"></button>`);
    const $span = $(`<span>${sizeText}</span>`);

    $btn.append($span);
    $li.append($btn);
    $popupList.append($li);
  });

  $popup.append($popupList);

  // Append popup below the select element
  $select.after($popup);

  // Simple fade-in animation
  $popup.hide().fadeIn(150);

  // Close popup when clicking outside
  $(document).one('click', function (e) {
    if (!$(e.target).closest('.custom-size-popup, .frcp-product__select').length) {
      $popup.fadeOut(150, function () {
        $(this).remove();
      });
    }
  });
});

$(document).on('click', '.custom-size-option', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const variantId = $(this).attr('data-vid');
  const requestedQty = 1;
  const $popup = $(this).closest('.custom-size-popup');

  // Hide popup immediately
  $popup.fadeOut(150, function () {
    $(this).remove();
  });

  // Perform add-to-cart AJAX
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    cache: false,
    data: { id: variantId, quantity: requestedQty },
    dataType: 'json',
    success: function () {
      $('cart-drawer').addClass('active');
      $('.drawer__inner-empty').hide();
      $('cart-drawer').removeClass('is-empty');

      $.get('/cart', function (response) {
        var cartDrawerContent = $(response).find('#CartDrawer').html();
        $('#CartDrawer').html(cartDrawerContent);
        $('#cart-icon-bubble').load(location.href + ' #cart-icon-bubble > *');

        const cartItemsComponent = document.querySelector('cart-items');
        if (cartItemsComponent) {
          cartItemsComponent.onCartUpdate();
        }
      });
    },
    error: function (err) {
      const errorMessage = err?.responseJSON?.description || 'Item could not be added to cart.';
      const $errorWrapper = $('.size_variant__error-message-wrapper');
      const $errorText = $('.size_variant__error-message');

      $errorText.text(errorMessage);
      $errorWrapper.removeAttr('hidden');

      setTimeout(() => {
        $errorWrapper.attr('hidden', true);
      }, 3000);
    },
  });
});
















document.addEventListener('click', function (e) {
  const tab = e.target.closest('.drawer__tab');
  if (!tab) return;

  const inner = tab.closest('.drawer__inner');
  if (!inner) return;

  const labels = inner.querySelector('.drawer__header-labels');
  if (!labels) return;

  const isWishlistActive = inner.querySelector('.drawer__tab--wishlist')?.classList.contains('is-active');
  const isBagActive = inner.querySelector('.drawer__tab--bag')?.classList.contains('is-active');

  // ✅ use inline display style instead of hidden attribute
  if (isWishlistActive && !isBagActive) {
    labels.style.display = 'none';
  } else {
    labels.style.display = '';
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.drawer__inner').forEach(inner => {
    const labels = inner.querySelector('.drawer__header-labels');
    if (!labels) return;

    const isWishlistActive = inner.querySelector('.drawer__tab--wishlist')?.classList.contains('is-active');
    const isBagActive = inner.querySelector('.drawer__tab--bag')?.classList.contains('is-active');

    if (isWishlistActive && !isBagActive) {
      labels.style.display = 'none';
    } else {
      labels.style.display = '';
    }
  });
});























